import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card } from "shared/components";

import "./TaskCardPreview.scss";

const TaskCardPreview = ({
  task,
  active = false,
  small = true,
  className = "",
  icon = "",
  renderTask,
}) => (
  <div className="task-card-preview" key={`task-${task.id}`} id={task.id}>
    <Card
      small={small}
      className={`${className} ${active ? "active" : "inactive"}`}
    >
      <div className="card-content" onClick={() => renderTask(task, active)}>
        <div className="icon-container">{icon}</div>
        <div className="">
          <p className="label">{task.name}</p>
          <p className="fw-bold mb-0">{task.name}</p>
        </div>
        <i className="material-icons md-36 chevron text-pacific-blue">
          chevron_right
        </i>
      </div>
    </Card>
  </div>
);

export default TaskCardPreview;

TaskCardPreview.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  active: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.node,
  renderTask: PropTypes.func.isRequired,
};
